import React from "react";
import { Link } from "react-router-dom";
import "./About.css";

function About() {
  return (
    <main className="tv-about-page">


      <section className="tv-about-hero">

        <div className="tv-about-hero-glow"></div>

       <div
  className="tv-about-hero-container"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(18, 36, 25, 0.45),
        rgba(18, 36, 25, 0.45)
      ),
      url("/about10.webp")
    `,
  }}
>
  <span className="tv-about-eyebrow">
    THE TIME VALLEY STORY
  </span>

  <div className="tv-about-line"></div>

  <h1>
    More Than A Watch.
    <br />
    <span>A Way Of Life.</span>
  </h1>

  <p>
    Time Valley was created for those who believe that
    time is not simply measured — it is experienced,
    remembered and made meaningful.
  </p>
</div>

        <div className="tv-about-hero-mark">
          OUR STORY
        </div>

      </section>

      <section className="tv-about-intro">

        <div className="tv-about-intro-container">

          <div className="tv-about-intro-left">

            <span className="tv-about-section-eyebrow">
              OUR PHILOSOPHY
            </span>

            <div className="tv-about-gold-line"></div>

            <h2>
              Time Is The
              <br />
              <span>Greatest Luxury.</span>
            </h2>

          </div>


          <div className="tv-about-intro-right">

            <p className="tv-about-large-text">
              At Time Valley, we believe a watch should be more
              than an accessory. It should carry character,
              reflect individuality and become part of the
              moments that matter.
            </p>

            <p>
              Every timepiece we present is selected with a
              simple philosophy in mind — timeless design,
              refined details and a presence that never depends
              on passing trends.
            </p>

            <p>
              From the first glance to every moment that follows,
              Time Valley is about celebrating the value of time.
            </p>

          </div>

        </div>

      </section>


      <section className="tv-about-story">

        <div className="tv-about-story-image">

          <img
            src="/logo10.png"
            alt="Time Valley luxury timepiece"
          />

        </div>


        <div className="tv-about-story-content">

          <span className="tv-about-section-eyebrow">
            THE TIME VALLEY DIFFERENCE
          </span>

          <div className="tv-about-gold-line"></div>

          <h2>
            Designed To
            <br />
            <span>Endure.</span>
          </h2>

          <p>
            True luxury does not need to demand attention.
            It speaks through proportion, detail and quiet
            confidence.
          </p>

          <p>
            This belief shapes everything we do at Time Valley.
            Our collections are built around sophisticated
            silhouettes, considered details and designs that
            remain relevant long after trends have passed.
          </p>

          <Link
            to="/collections"
            className="tv-about-button"
          >
            Explore Our Collections
            <span>→</span>
          </Link>

        </div>

      </section>


      <section className="tv-about-values">

        <div className="tv-about-values-container">

          <div className="tv-about-value-card">

            <span className="tv-about-value-number">
              01
            </span>

            <span className="tv-about-value-label">
              OUR VISION
            </span>

            <h3>
              Make Every
              <br />
              <span>Moment Count.</span>
            </h3>

            <p>
              To create a watch experience that feels personal,
              refined and timeless — giving every wearer a piece
              that belongs to their story.
            </p>

          </div>


          <div className="tv-about-value-card">

            <span className="tv-about-value-number">
              02
            </span>

            <span className="tv-about-value-label">
              OUR MISSION
            </span>

            <h3>
              Redefining
              <br />
              <span>Everyday Luxury.</span>
            </h3>

            <p>
              To bring thoughtfully designed timepieces to
              modern individuals who appreciate quality,
              character and timeless elegance.
            </p>

          </div>

        </div>

      </section>

      <section className="tv-about-craft">

        <div className="tv-about-craft-container">

          <div className="tv-about-craft-heading">

            <span className="tv-about-section-eyebrow">
              THE ART OF WATCHMAKING
            </span>

            <div className="tv-about-gold-line"></div>

            <h2>
              Details That
              <br />
              <span>Tell A Story.</span>
            </h2>

          </div>


          <div className="tv-about-craft-grid">

            <div className="tv-about-craft-item">

              <span>01</span>

              <h3>Refined Design</h3>

              <p>
                Balanced proportions and sophisticated
                details create a distinctive presence
                on the wrist.
              </p>

            </div>


            <div className="tv-about-craft-item">

              <span>02</span>

              <h3>Timeless Character</h3>

              <p>
                We focus on designs that remain elegant
                beyond seasons, trends and passing moments.
              </p>

            </div>


            <div className="tv-about-craft-item">

              <span>03</span>

              <h3>Made For You</h3>

              <p>
                Every collection is created to complement
                different personalities, occasions and
                expressions of style.
              </p>

            </div>

          </div>

        </div>

      </section>


      <section className="tv-about-cta">

        <div className="tv-about-cta-glow"></div>

        <div className="tv-about-cta-container">

          <span className="tv-about-section-eyebrow">
            YOUR TIME. YOUR STORY.
          </span>

          <div className="tv-about-gold-line"></div>

          <h2>
            Find The Watch
            <br />
            <span>That Defines You.</span>
          </h2>

          <p>
            Discover the Time Valley collection and find a
            timepiece designed to become part of your story.
          </p>

          <Link
            to="/shop"
            className="tv-about-button tv-about-button-light"
          >
            Discover Time Valley
            <span>→</span>
          </Link>

        </div>

      </section>

    </main>
  );
}

export default About;
